import { FC, useEffect } from 'react';

import { getStaticPrefix } from '@eneco/common/env';
import useDC from '@eneco/dc/useDC';
import { I18nProvider, useTranslation } from '@eneco/i18n';
import { Skeleton } from '@eneco/sparky';
import { useTracking } from '@eneco/tracking';

import { useMeterReadingsFlow } from '../../../../state/MeterReadingsFlow.machine';
import { Steps } from '../../../../tracking';
import { Simple } from '../../../templates/Simple';

export const RelocationOldAddress: FC = () => {
  const { label } = useDC();

  return (
    <I18nProvider dictionary={locale => import(`./content/RelocationOldAddress.${label}.${locale}.json`)}>
      <RelocationOldAddressComponent />
    </I18nProvider>
  );
};

export const RelocationOldAddressComponent: FC = () => {
  const { label } = useDC();
  const { t, isLoading } = useTranslation();
  const { trackFunnelCompleted } = useTracking();
  const { state } = useMeterReadingsFlow();

  useEffect(() => {
    trackFunnelCompleted({
      step: Steps['THANK_YOU.RelocationOldAddress'],
      funnel: state.context.funnelName,
    });
  }, [state.context.funnelName, trackFunnelCompleted]);

  if (isLoading) return <Skeleton height={450} />;

  return (
    <Simple
      title={t('relocationOldAddress.title')}
      content={t('relocationOldAddress.content')}
      buttonHref={t('relocationOldAddress.buttonLink.href')}
      buttonText={t('relocationOldAddress.buttonLink.text')}
      nextStepList={[
        {
          label: t('relocationOldAddress.nextStep1'),
          state: 0,
        },
        {
          label: t('relocationOldAddress.nextStep2'),
          state: 0,
        },
        {
          label: t('relocationOldAddress.nextStep3'),
          state: 1,
        },
      ]}
      heroImage={{
        value: {
          src: `${getStaticPrefix()}/images/${label}/meterreadings/${t('relocationOldAddress.imageSrc')}`,
        },
      }}
    />
  );
};
